import { HttpParameterCodec } from '@angular/common/http';

/**
 * Custom HttpParameterCodec
 * Workaround for https://github.com/angular/angular/issues/18261
 */
/**
 * Handles customhttpparametercodec for this module.
 */
export class CustomHttpParameterCodec implements HttpParameterCodec {
    /**
     * Handles encodekey for this module.
     */
    encodeKey(k: string): string {
        return encodeURIComponent(k);
    }
    /**
     * Handles encodevalue for this module.
     */
    encodeValue(v: string): string {
        return encodeURIComponent(v);
    }
    /**
     * Handles decodekey for this module.
     */
    decodeKey(k: string): string {
        return decodeURIComponent(k);
    }
    /**
     * Handles decodevalue for this module.
     */
    decodeValue(v: string): string {
        return decodeURIComponent(v);
    }
}


